// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconDashboard, IconListCheck } from '@tabler/icons';
import { OverrideIcon } from 'types';
import { AutoModeOutlined, Insights, AutoAwesomeOutlined, FlagOutlined, PollOutlined, VerifiedOutlined,AssignmentTurnedInOutlined, BusinessCenterOutlined, MonetizationOnOutlined, TrackChangesOutlined } from '@mui/icons-material';
import { FeatureFlags, PermissionTypeEnum } from 'types/user-profile';

// constant
const icons = {
    IconDashboard,
    PollOutlined,
    IconListCheck,
    FlagOutlined
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface DashboardMenuProps {
    id: string;
    title?: React.ReactNode | string;
    type: string;
    children: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
       // adminOnly?: boolean; 
        systemAdminOnly?: boolean; 
        developerOnly?: boolean;
        requeredPermission?:PermissionTypeEnum[];
        isLocked?:true;
        feature?:FeatureFlags;
    }[];
}

const dashboard: DashboardMenuProps = {
    id: 'dashboard',
    // title: <FormattedMessage id="Campaign management" />,
    type: 'group',
    children: [
        // {
        //     id: 'managerdashboard_old',
        //     title: <FormattedMessage id="manager dashboard" />,
        //     type: 'item',
        //     url: '/dashboard/managerdashboard_old',
        //     icon: icons.PollOutlined,
        //     breadcrumbs: true,
        //     requeredPermission: [PermissionTypeEnum.ManagementReports]
        //    // systemAdminOnly: true
        // },
        //  {
        //     id: 'managerdashboard',
        //     title: <FormattedMessage id="Media Dashboard" />,
        //     type: 'item',
        //     url: '/dashboard/managerdashboard',
        //     icon: icons.PollOutlined,
        //     breadcrumbs: true,
        //     requeredPermission: [PermissionTypeEnum.ManagementReports]
        //    // systemAdminOnly: true
        // },
        // {
        //     id: 'systemmonitoring',
        //     title: <FormattedMessage id="Agency Status" />,
        //     type: 'item',
        //     url: '/systemMonitoring',
        //     icon: icons.FlagOutlined,
        //     breadcrumbs: true,
        //     requeredPermission: [PermissionTypeEnum.ManagementReports, PermissionTypeEnum.OperationalReports]
        //    // isLocked:true
        // },
        // {
        //     id: 'accounts',
        //     title: <FormattedMessage id="accounts" />,
        //     type: 'item',
        //     url: '/accounts/list',
        //     icon: BusinessCenterOutlined,
        //     breadcrumbs: true
        // },
        // {
        //     id: 'ai_analytics',
        //     title: <FormattedMessage id="ai analytics" />,
        //     type: 'item',
        //     url: '/ai_analytics',
        //     icon: AutoAwesomeOutlined,
        //     breadcrumbs: true,
        //    // systemAdminOnly: true
        //     // isLocked:true
        // },
        // {
        //     id: 'reports',
        //     title: <FormattedMessage id="Reports" />,
        //     type: 'item',
        //     url: '/performance/list',
        //     icon: Insights,
        //     breadcrumbs: true,
        //     requeredPermission: [PermissionTypeEnum.OperationalReports]
        // },
        
        
       
    ]
};

export default dashboard;
